import React, { useState, useEffect } from 'react';
import ClaseInfo from './ClaseInfo';
import { db } from './firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import { holidays, courseDates } from './courseDates';

const ScheduleTable = () => {
    const [selectedClass, setSelectedClass] = useState(null);
    const [reservasDB, setReservasDB] = useState([]);
    const [ageFilter, setAgeFilter] = useState('0-12');
    const [expandedRowIndex, setExpandedRowIndex] = useState(null);

    useEffect(() => {
        const unsub = onSnapshot(collection(db, "reservas"), (snap) => {
            setReservasDB(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });
        return () => unsub();
    }, []);

    // Base slots for the 8-Week Journey
    const baseSlots = [
        { day: 'Tuesday', time: '10:00 - 11:00', age: '0-12 months', group: 'Babies' },
        { day: 'Tuesday', time: '11:15 - 12:15', age: '1-3 years', group: 'Toddlers' },
        { day: 'Wednesday', time: '10:00 - 11:00', age: '1-3 years', group: 'Toddlers' },
        { day: 'Wednesday', time: '11:15 - 12:15', age: '0-12 months', group: 'Babies' },
    ];

    const filteredData = baseSlots.filter(row => row.age.includes(ageFilter));

    const getSubscriptionDates = (day) => {
        const datesArr = day === 'Tuesday' ? courseDates.c3_tue : courseDates.c3_wed;
        return datesArr.filter(d => !holidays.includes(d));
    };

    const formatSimpleDate = (dateStr) => {
        const [year, month, day] = dateStr.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };

    return (
        <div className="schedule-section">
            <div className="booking-controls">
                <div className="age-filters">
                    <span>Filter by age:</span>
                    <button className={`filter-btn ${ageFilter === '0-12' ? 'active' : ''}`} onClick={() => setAgeFilter('0-12')}>0-12 months</button>
                    <button className={`filter-btn ${ageFilter === '1-3' ? 'active' : ''}`} onClick={() => setAgeFilter('1-3')}>1-3 years</button>
                </div>
            </div>

            <div className="schedule-table-container">
                <table className="schedule-table">
                    <thead>
                        <tr>
                            <th>Day</th>
                            <th>Time</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((row, index) => {
                            const subBookings = reservasDB.filter(r => 
                                r.tipo_registro === "Subscription" && 
                                r.dia === row.day && 
                                r.horario === row.time && 
                                r.edad_rango === row.age
                            ).length;
                            
                            const isFull = subBookings >= 7;
                            const buttonText = isFull ? 'FULLY BOOKED' : 'Join the 8-Week Journey';
                            const statusMessage = isFull ? 'This session is now full' : '7 spots available';
                            const isExpanded = expandedRowIndex === index;

                            return (
                                <React.Fragment key={index}>
                                    <tr style={{ borderBottom: isExpanded ? 'none' : '' }}>
                                        <td className="st-day">
                                            <div style={{ fontWeight: 'bold', color: 'var(--primary-blue)' }}>{row.day}</div>
                                            <div 
                                                className="view-dates-toggle" 
                                                onClick={() => setExpandedRowIndex(isExpanded ? null : index)}
                                            >
                                                📅 <span>{isExpanded ? 'Hide class dates' : 'View class dates'}</span>
                                            </div>
                                        </td>
                                        <td className="st-time">{row.time}</td>
                                        <td className="st-action">
                                            <button 
                                                className="btn-book-table" 
                                                onClick={() => setSelectedClass({ ...row, productType: 'subscription' })}
                                                disabled={isFull}
                                                style={isFull ? { backgroundColor: '#ccc', borderColor: '#ccc', cursor: 'not-allowed' } : {}}
                                            >
                                                {buttonText}
                                            </button>
                                            <div style={{ fontSize: '11px', color: isFull ? '#e65100' : '#666', marginTop: '4px' }}>
                                                {statusMessage}
                                            </div>
                                        </td>
                                    </tr>
                                    {isExpanded && (
                                        <tr className="expanded-dates-row">
                                            <td colSpan="3">
                                                <div className="dates-grid">
                                                    {getSubscriptionDates(row.day).map((d, i) => (
                                                        <div key={i} className="date-tag">{formatSimpleDate(d)}</div>
                                                    ))}
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {selectedClass && (
                <ClaseInfo 
                    selectedClass={selectedClass} 
                    onClose={() => setSelectedClass(null)} 
                />
            )}
        </div>
    );
};

export default ScheduleTable;
